import { FC } from 'react';
import { Button, Col, Form, Input, InputNumber, message, Row, Spin } from "antd";
import * as React from "react";
import restful from '../../restful';
import SelectRoleField from '../fields/select-role-field';
import Password from 'antd/lib/input/Password';
import TextArea from 'antd/lib/input/TextArea';
import SelectPublishField from '../fields/select-publish-field';
import UploadFileField from '../fields/upload-file-field';

interface Prop { id: string | null }

const CategoryForm: FC<Prop> = ({ id }) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = React.useState(false)

	React.useEffect(() => {
		if (id === null) return
		setLoading(true)
		restful.get('categories/' + id+"/form")
			.then((res) => {
				res.data.result.form.published = res.data.result.form.published + ''
				form.setFieldsValue(res.data.result.form)
			})
			.catch((err) => message.error(err.message))
			.finally(() => setLoading(false));;
	}, [])

	function onFinish(data: any) {
		setLoading(true)
		restful.request({
			data,
			method: id ? "PUT" : "POST",
			url: id ? `/categories/${id}` : "/categories"
		}).then((res) => {
			if (id === null) form.resetFields()
			message.success("انجام شد")
		})
			.catch((err) => message.error(err.message))
			.finally(() => setLoading(false));
	}

	return (





		<Spin spinning={loading} >
			<Form form={form} onFinish={onFinish} layout="vertical"  autoComplete='off'>
				<Row gutter={16}>

					<Col xs={24} md={12}  >
						<Form.Item name="title" label="عنوان"
							rules={[
								{ required: id === null, message: "این فیلد ضروری است" },
							]}
						>
							<Input />
						</Form.Item>
					</Col>

					<Col xs={24} md={12}  >
						<Form.Item name="description" label="توضیحات"
							rules={[
								{ required: id === null, message: "این فیلد ضروری است" },
							]}
						>
							<TextArea />
						</Form.Item>
					</Col>

					<Col xs={24} md={12}  >
						<Form.Item name="image" label="تصویر"
							rules={[
								{ required: id === null, message: "این فیلد ضروری است" },
							]}
						>
							<UploadFileField />
						</Form.Item>
					</Col>

					<Col xs={24} md={12}  >
						<Form.Item name="published" label="انتشار"
							rules={[
								{ required: id === null, message: "این فیلد ضروری است" },
							]}
						>
							<SelectPublishField />
						</Form.Item>
					</Col>


					<Col span={24} style={{ textAlign: 'left' }}>
						<Button type="primary" htmlType="submit">ثبت</Button>
					</Col>
				</Row>
			</Form>
		</Spin>
	)
}

export default CategoryForm;
